export const SUPER_ADMIN_FILTER_NAME = 'SUPER_ADMIN';
// MMS GROUPS KEYS
export const MMS_GROUPS_KEY = 'MMS_GROUPS';
export const MANUFACTURER_KEY = 'MANUFACTURER';
export const MODEL_KEY = 'MODEL';
export const SERIES_KEY = 'SERIES';
export const SUB_MODEL_KEY = 'SUB_MODEL';
// MM GROUPS EXCLUDE KEYS
export const MM_GROUPS_EXCLUDE_KEY = 'MM_GROUPS_EXCLUDE';
export const MANUFACTURER_EXCLUDE_KEY = 'MANUFACTURER_EXCLUDE';
export const MODEL_EXCLUDE_KEY = 'MODEL_EXCLUDE';
export const SERIES_EXCLUDE_KEY = 'SERIES_EXCLUDE';
// ALL GROUPS KEYS
export const MMS_GROUPS_ITEMS = [
    MANUFACTURER_KEY, MODEL_KEY, SERIES_KEY, SUB_MODEL_KEY,
    MANUFACTURER_EXCLUDE_KEY, MODEL_EXCLUDE_KEY, SERIES_EXCLUDE_KEY
];
export const HIGHLIGHTS_KEY = 'HIGHLIGHTS';
export const BODY_TYPE_KEY = 'BODY_TYPE';
export const DRIVE_TYPE_KEY = 'DRIVE_TYPE';
export const TRANSMISSION_KEY = 'TRANSMISSION';
export const STATE_OPTIONS_KEY = 'STATE_OPTIONS';
export const POWER_KEY = 'POWER';
export const VEHICLE_CONDITION_KEY = 'VEHICLE_CONDITION';
export const OWNERS_KEY = 'OWNERS';
export const MILEAGE_KEY = 'MILEAGE';
export const BODY_COLOR_KEY = 'BODY_COLOR';
export const INTERIOR_COLOR_KEY = 'INTERIOR_COLOR';
export const PRICE_KEY = 'PRICE';
export const RATE_KEY = 'RATE';
export const MAX_FILTERS_IN_TITLE = 3;
export const FILTERS_IN_TITLE = [
    MMS_GROUPS_KEY, BODY_TYPE_KEY, DRIVE_TYPE_KEY, TRANSMISSION_KEY, STATE_OPTIONS_KEY, BODY_COLOR_KEY, INTERIOR_COLOR_KEY, HIGHLIGHTS_KEY,
    VEHICLE_CONDITION_KEY, OWNERS_KEY, 'EMISSION_STICKER', 'PARTICULATE_FILTER', 'EMISSION_CLASS', 'FUEL', 'CONSUMPTION', 'STATE_OPTIONS_NEW', 'USAGE_TYPE',
    'GENERAL_INSPECTION', 'LIGHTS', 'DOORS_OPTIONS', 'MIRRORS_OPTIONS', 'EXTRAS_OPTIONS', 'WINDOW_OPTIONS', 'LANDING_GEAR', 'MULTIMEDIA', 'SEATS_OPTIONS',
    'DRIVER_SEATS', 'CO_DRIVER_SEATS', 'BACK_SEATS', 'WHEEL', 'HEATER', 'CLIMATISATION',
    'ASSISTANTS', 'AIRBAG', 'PARKING_ASSISTANTS', 'THEFT_PROTECTION', 'HIGHLIGHTS',
    'INTERIOR_COLOR', 'INTERIOR_TYPE', 'METALLIC',
    MM_GROUPS_EXCLUDE_KEY, 'FIRST_REGISTRATION',
    'PRICE', 'RATE', 'MILEAGE', 'POWER', 'CONSUMPTION', 'SEATS', 'DOORS', 'FUEL'
];
export const MMS_GROUP_OBJ = {
    MANUFACTURER: { agg: 'MANUFACTURER', field: 'mainData_make', options: [], value: '', isAbsolute: true },
    MODEL: { agg: 'MODEL', field: 'mainData_model', options: [], value: '', isAbsolute: true },
    SUB_MODEL: { agg: 'SUB_MODEL', field: 'mainData_subModel', value: '', isAbsolute: true },
    SERIES: { agg: 'SERIES', field: 'mainData_series', value: '', isAbsolute: true }
};
export const MM_GROUP_EXCLUDE_OBJ = {
    MANUFACTURER_EXCLUDE: { agg: 'MANUFACTURER', field: 'mainData_make', options: [], value: '', isAbsolute: true },
    MODEL_EXCLUDE: { agg: 'MODEL', field: 'mainData_model', options: [], value: '', isAbsolute: true },
    SERIES_EXCLUDE: { agg: 'SERIES', field: 'mainData_series', options: [], value: '', isAbsolute: true }
};
export const MMS_GROUP_NAME = 'mmsGroup';
export const MM_EXCLUDE_GROUP_NAME = 'mmsNotGroup';
export const MODEL_FIELD_NAME = 'mainData_model';
export const THROTTLE_DELAY = 1000;
export const MIN_ALTERNATIVE_CARS = 25;
export const HISTOGRAM_KEY = 'HISTOGRAM';
export const RANGE_SLIDER_CONFIG = {
    width: 220,
    padding: 0,
    selectedColor: '#005CCB',
    unselectedColor: '#AFBDD8',
    height: 90,
    histogramStyle: {
        opacity: 0.4,
        borderRadius: 0
    },
    structureScheme: ['from', 'to'],
    dataLength: 20
};
export const VEHICLE_ID = {
    field: 'metaData_vehicleId',
    isAbsolute: true
};
export const RANGE_FILTERS = {
    FIRST_REGISTRATION: {
        options: [{ from: 2011, to: 2019, count: 0 }],
        defaultValue: { from: 2011, to: 2019 }
    },
    PRICE: {
        options: [{ from: 0, to: 1000, count: 0 }],
        defaultValue: { from: 0, to: 90000 }
    },
    PRICE_DIFFERENCE: {
        options: [{ from: 0, to: 1000, count: 0 }],
        defaultValue: { from: 0, to: 90000 }
    },
    MILEAGE: {
        options: [{ from: 0, to: 1000, count: 0 }],
        defaultValue: { from: 0, to: 150000 }
    },
    POWER: {
        options: [{ from: 0, to: 100, count: 0 }],
        defaultValue: { from: 0, to: 600, type: 'PS' },
        typeOptions: ['PS', 'KW']
    },
    SEATS: {
        options: [{ from: 1, to: 12 }],
        defaultValue: { from: undefined, to: undefined }
        // old default value for slider
        // defaultValue: { from: 1, to: 12 }
    },
    CONSUMPTION: {
        options: [{ from: 1, to: 18 }],
        defaultValue: { from: undefined, to: undefined }
        // old default value for slider
        // defaultValue: { from: 1, to: 18 }
    },
    CUBIC_CAPACITY: {
        options: [{ from: 0, to: 1000, count: 0 }],
        defaultValue: { from: 0, to: 9000 }
    },
    IMAGES_COUNT: {
        options: [{ from: 0, to: 100, count: 0 }],
        defaultValue: { from: 0, to: 100 }
    },
    EMISSION_CO2: {
        options: [{ from: 0, to: 1000, count: 0 }],
        defaultValue: { from: 0, to: 1500 }
    }
};
export const OBJECT_FILTERS = {
    RATE: {
        defaultValue: { monthlyInstallmentFrom: null, monthlyInstallmentTo: null, firstInstallment: null, paybackPeriod: null }
    }
};
export const RANGE_FILTERS_DEFAULT_CONTROLS = { from: '', to: '' };
export const POWER_DEFAULT_CONTROLS = { from: '', to: '', type: 'PS' };
export const RATE_DEFAULT_CONTROLS = { monthlyInstallmentFrom: 'any', monthlyInstallmentTo: 'any', firstInstallment: 0, paybackPeriod: 60 };
/* eslint-disable */
export const PRICES_FIX = [
    500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000,
    6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000,
    17500, 20000, 22500, 25000, 27500, 30000, 35000, 40000, 45000, 50000, 55000, 60000,
    70000, 80000, 90000
];
export const MILLAGE_FIX = [
    0, 5000, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 125000, 150000
];
export const SEATS_FIX = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
];
export const POWER_FIX = [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 250, 300, 350, 400, 450, 500, 600
];
export const CUBIC_CAPACITY_FIX = [
    1000, 1200, 1400, 1600, 1800, 2000, 2600, 3000, 5000, 7500, 8000, 9000
];
export const IMAGES_COUNT_FIX = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 35, 40, 45, 50, 75, 100
];
// l/100km
export const CONSUMPTION_FIX = [
    3, 4, 5, 6, 7, 8, 9, 10, 12, 15
];
export const FIRST_INSTALLMENT_FIX = [
    0, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, // eslint-disable-line
    6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000, // eslint-disable-line
    17500, 20000, 22500, 25000, 27500, 30000, 35000, 40000, 45000, 50000 // eslint-disable-line
];
export const MONTHLY_INSTALLMENT_FIX = [
    'any', 50, 60, 70, 80, 90, 100, 125, 150, 175, 200, 225, 250, 275, 300, 350, 400, 450, 500, // eslint-disable-line
    550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1100, 1200, 1300, 1400, 1500 // eslint-disable-line
];
export const PAYBACK_PERIOD_FIX = [
    12, 24, 36, 48, 60, 72, 84, 96 // eslint-disable-line
];
/* eslint-enable */
export const GENERAL_INSPECTION_PERIOD_EXPIRED = [
    { key: '6_months', value: 6 }, // insert value in months
    { key: '12_months', value: 12 },
    { key: '18_months', value: 18 }
];
export const MMS_GROUP_KEYS_SET = new Set([MANUFACTURER_KEY, MODEL_KEY, SERIES_KEY, SUB_MODEL_KEY]);
export const ALTERNATIVE_FILTER_KEYS = [
    HIGHLIGHTS_KEY, DRIVE_TYPE_KEY, POWER_KEY, TRANSMISSION_KEY, VEHICLE_CONDITION_KEY, MILEAGE_KEY, INTERIOR_COLOR_KEY, BODY_COLOR_KEY, BODY_TYPE_KEY,
    SERIES_KEY, SUB_MODEL_KEY, MODEL_KEY, MANUFACTURER_KEY, ...Object.keys(RANGE_FILTERS)
];
export const DOOR_KEYS = ['two_doors', 'three_doors', 'four_doors', 'five_doors', 'all_doors'];
export const SINLGE_DOOR_KEYS = ['two_doors', 'three_doors', 'four_doors', 'five_doors'];
export const ALL_DOORS_KEY = 'all_doors';
export const COST_TYPE_OPTIONS = ['rate', 'price'];
export const COST_TYPE_DEFAULT = 'rate';
/* eslint-enable max-len */
